var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19443",
    "data-name": "Group 19443",
    transform: "translate(-17937 22080)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M1.5,13A1.5,1.5,0,0,1,0,11.5V7.326a1.5,1.5,0,0,1,1.5-1.5h.4L7.579,1.941,1.895,5.826H16.1L10.421,1.941,16.1,5.826h.4a1.5,1.5,0,0,1,1.5,1.5V11.5A1.5,1.5,0,0,1,16.5,13ZM7.579,1.456a1.422,1.422,0,1,1,2.842,0,1.422,1.422,0,1,1-2.842,0Z",
    transform: "translate(17937.5 -22079.5)",
    fill: "none",
    stroke: "#c3c3c3",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_123",
    "data-name": "#123",
    transform: "translate(17941 -22068.5)",
    fill: "#c3c3c3",
    fontSize: 5,
    fontFamily: "TitilliumWeb-SemiBold, Titillium Web",
    fontWeight: 600,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "#123")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomNumber);
export default __webpack_public_path__ + "static/media/roomNumber.f3f53d08b5f8ae0f20d7c1cbc60cfa99.svg";
export { ForwardRef as ReactComponent };